// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "static/js/a18f26c4c7823ff1ae9a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"5f26dfbf08c608e3d780","140":"c99aa65041543744da35","141":"3f2a183740067b145022"}[chunkId] + ".chunk.js";
};